<template>
  <div class="sync-app-page container">
    <h2>Use the Sync app to upload your tree</h2>
    <div v-if="!currentOS" class="alert alert-primary alert-sm">
      The Sync app works with desktop genealogy programs. The app is available on Windows and MacOS.
    </div>
    <SyncAppTile/>
    <div class="gen-apps">
      <div>Supported genealogy programs:</div>
      <AppSupportGrid/>
    </div>
    <div class="more-info">
      <router-link :to="{ name: 'sync' }">Learn more about the Sync app</router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sync-app-page {
  padding-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

h2 {
  margin-bottom: 3rem;
  text-align: center;
}

.gen-apps {
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.more-info {
  margin-top: 3rem;
  text-align: center;
}
</style>

<script lang="ts" setup>
import { usePageTitle } from '@/util/AppUtil'
import { currentOS } from '@/rd/ResearchDataModel'
import SyncAppTile from '@/sync/SyncAppTile.vue'
import AppSupportGrid from './AppSupportGrid.vue'

usePageTitle('Get the Sync app')
</script>
